import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
interface UrgencyCloseProps {
  cartLink: string;
}
export const UrgencyClose: React.FC<UrgencyCloseProps> = ({
  cartLink
}) => {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-242">
      <div className="max-w-3xl mx-auto" data-id="element-243">
        <div className="text-center mb-12" data-id="element-244">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-red-600 mb-6" data-id="element-245">
            ESTA OFERTA TERMINA PRONTO
          </h2>
          <p className="text-xl text-gray-800 font-medium" data-id="element-246">Escúchame bien:</p>
          <p className="text-lg text-gray-700 mt-2" data-id="element-247">
            Esta página puede desaparecer en cualquier momento después del 25 de
            Enero de 2026.
          </p>
          <p className="text-lg text-gray-700 mt-2" data-id="element-248">
            Y cuando eso pase… el precio subirá.
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-brand-blush mb-16" data-id="element-249">
          <h3 className="text-2xl font-serif font-bold mb-6" data-id="element-250">
            Así que tienes una decisión:
          </h3>

          <div className="space-y-8" data-id="element-251">
            <div data-id="element-252">
              <p className="font-bold text-red-600 mb-2" data-id="element-253">Seguir atrapada:</p>
              <ul className="list-disc pl-6 space-y-1 text-gray-700" data-id="element-254">
                <li data-id="element-255">sobrepensando</li>
                <li data-id="element-256">revisando mensajes</li>
                <li data-id="element-257">sintiéndote reemplazable</li>
                <li data-id="element-258">persiguiendo claridad emocional</li>
              </ul>
            </div>

            <div className="text-center font-serif font-bold text-2xl text-gray-400" data-id="element-259">
              O…
            </div>

            <div data-id="element-260">
              <p className="font-bold text-emerald-600 mb-2" data-id="element-261">
                Convertirte en la mujer que transmite calma, valor y presencia
                emocional naturalmente.
              </p>
              <p className="text-gray-700" data-id="element-262">
                La mujer que no necesita perseguir para ser deseada.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-16" data-id="element-263">
          <h2 className="text-3xl font-serif font-bold mb-8" data-id="element-264">
            Toma Acción Ahora
          </h2>

          <div className="mb-6" data-id="element-265">
            <span className="text-gray-500 font-medium mr-3" data-id="element-266">
              Antes: <PriceDisplay basePriceARS={40000} strikeThrough data-id="element-267" />
            </span>
          </div>

          <CTAButton href={cartLink} className="py-5 text-xl w-full md:w-auto px-12" data-id="element-268">
            Obtener Acceso Instantáneo por{' '}
            <PriceDisplay basePriceARS={25990} className="ml-1" data-id="element-269" />
          </CTAButton>

          <div className="mt-6 flex flex-col items-center gap-2" data-id="element-270">
            <span className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm font-bold" data-id="element-271">
              🎁 Oferta -50% OFF sólo 20 cupos
            </span>
            <span className="text-brand-wine font-medium text-sm animate-pulse" data-id="element-272">
              ⚡ Últimos 3 Cupos en Oferta!
            </span>
            <span className="text-gray-500 text-sm mt-2" data-id="element-273">
              Pago único. Sin mensualidades.
            </span>
          </div>
        </div>

        {/* P.S. Section */}
        <div className="space-y-8 text-lg text-gray-800 border-t-2 border-brand-gold/20 pt-12" data-id="element-274">
          <div data-id="element-275">
            <p className="font-serif font-bold text-xl mb-2" data-id="element-276">P.S.</p>
            <p data-id="element-277">Recuerda…</p>
            <p data-id="element-278">
              Tienes 60 días completos para probar absolutamente TODO sin
              riesgo.
            </p>
            <p data-id="element-279">
              Estoy completamente segura de que esta guía cambiará la forma en
              que experimentas las relaciones.
            </p>
            <p data-id="element-280">Pero si no es así… te devolvemos cada centavo.</p>
          </div>

          <div data-id="element-281">
            <p className="font-serif font-bold text-xl mb-2" data-id="element-282">P.P.S.</p>
            <p className="font-bold" data-id="element-283">Esta oferta es TEMPORAL.</p>
            <p data-id="element-284">
              Una vez termine el lanzamiento… el precio aumentará y esta página
              desaparecerá.
            </p>
            <p className="italic mt-4 text-brand-wine font-medium" data-id="element-285">
              No esperes a tocar fondo emocionalmente para empezar a cambiar la
              dinámica.
            </p>
          </div>
        </div>
      </div>
    </section>;
};